module.exports = "/assets/b7f1f6113c80ebe7e12bae301c941704.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JJ.png
// module id = 1512
// module chunks = 0